import { render, staticRenderFns } from "./GatewayDetails.vue?vue&type=template&id=4406f115&scoped=true&"
import script from "./GatewayDetails.vue?vue&type=script&lang=js&"
export * from "./GatewayDetails.vue?vue&type=script&lang=js&"
import style0 from "./GatewayDetails.vue?vue&type=style&index=0&id=4406f115&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4406f115",
  null
  
)

export default component.exports